/**
 * The marketing team's inbox, and the mail links that reach it.
 *
 * One source of truth on purpose: the address is now on the Paid Performance
 * pilot tabs and the header button as well as the MIAB announcement, and an
 * address that drifts between copies is the kind of thing nobody notices until
 * a franchisee's mail bounces.
 */
export const MARKETING_EMAIL = 'marketing@amadafranchise.com';

/** Build a mailto: with a prefilled subject and body. */
export function mailto(subject: string, body?: string): string {
  const q = new URLSearchParams({ subject });
  if (body) q.set('body', body);
  // URLSearchParams encodes spaces as "+", which mail clients show literally in
  // a subject line. mailto wants percent-encoding.
  return `mailto:${MARKETING_EMAIL}?${q.toString().replace(/\+/g, '%20')}`;
}

/** "I'd like to join the X pilot" — used by the coming-soon channel tabs. */
export function pilotMailto(channel: string): string {
  return mailto(
    `${channel} pilot — enrollment inquiry`,
    `Hi marketing team,\n\n` +
      `I'd like to enroll in the ${channel} pilot and would like some more information about it.\n\n` +
      `Thanks,\n`,
  );
}
